/**
 * VEC-3763 — Valida los montos máximos de aprobación N1/N2 del ABM de Servicios.
 *
 * Espeja la regla del backend (ServicioService::validarNivelesAprobacion): un nivel vacío
 * significa "sin límite" —así lo anuncia el placeholder de ambos inputs— y con un nivel sin
 * límite no se compara N1 <= N2.
 *
 * El chequeo de vacío es explícito a propósito: la versión anterior usaba `N1 == ''`, y en JS
 * `0 == ''` da true por coerción, así que un monto guardado en 0 se interpretaba como campo
 * vacío y bloqueaba el guardado del servicio entero.
 */
export const esVacio = (valor) =>
  valor === null || valor === undefined || String(valor).trim() === '';

const esNumeroInvalido = (valor) => isNaN(Number(valor));

export const validarNivelesAprobacion = (n1, n2) => {
  const n1SinLimite = esVacio(n1);
  const n2SinLimite = esVacio(n2);

  if (!n1SinLimite && esNumeroInvalido(n1)) return false;
  if (!n2SinLimite && esNumeroInvalido(n2)) return false;

  if (n1SinLimite || n2SinLimite) return true;

  return Number(n1) <= Number(n2);
};

/**
 * El input vacío queda como '' en el state, y `setMontoMaximoAprobacionN1(?float)` tira
 * TypeError con un string no numérico. "Sin límite" viaja como null, no como ''.
 */
export const normalizarMonto = (valor) => (esVacio(valor) ? null : valor);

/**
 * El camino inverso de normalizarMonto(): del backend al input.
 *
 * Un monto en NULL llega como null y React no pisa el DOM cuando el input se renderiza con
 * `value={null}`, así que quedaba a la vista el 0 del estado inicial — el significado opuesto a
 * "sin límite". Con '' el input queda vacío y muestra el placeholder.
 */
export const montoParaInput = (valor) => (valor === null || valor === undefined ? '' : valor);
